// PayslipPdf.js
import { Document, Page, Text, View } from "@react-pdf/renderer";
import React from "react";

import dayjs from "dayjs";
import { formatIndianCurrency, getMonthInStringNotOneIndexBased } from "../../../utils/common";
import { logger } from "../../../utils/logger";
import ReportHeader from "../report-header";
import { fonts, reportStyles } from "../report-style";
fonts();
const EPFPdf = ({ epfReportPDFData, epfReportSummary, organizationInfo }) => {
  logger.log(epfReportPDFData, "epfReportPDFData1000");
  logger.log(epfReportSummary, "epfReportSummary1000");
  const totalEmployeeUnder58 = epfReportPDFData.filter(employee => employee?.employees?.age <= 58).length;
  const totalEPSAmount = epfReportPDFData?.reduce((total, item) => {
    const employerEPSPercentage = Number((item?.epf_wages * 8.33) / 100).toFixed(2);
    const employerEPSAmount =
      item?.employees?.age <= 58
        ? employerEPSPercentage <= 1250
          ? Math.ceil(employerEPSPercentage)
          : 1250
        : 0;
    return total + Math.ceil(Number(employerEPSAmount));
  }, 0);
  const totalEPFAmount=epfReportPDFData?.reduce((total, item) => {
    const employerEPSPercentage = Number((item?.epf_wages * 8.33) / 100).toFixed(2);
    const employerEPSAmount =
      item?.employees?.age <= 58
        ? employerEPSPercentage <= 1250
          ? Math.ceil(employerEPSPercentage)
          : 1250
        : 0;
    const employerEPFAmount = Math.floor(Number(item?.ee_epf_amount - employerEPSAmount))
    return total + employerEPFAmount;
  },0);
  const totalEPSWages=epfReportPDFData?.reduce((total,item)=>{
    if (item?.epf_wages && Number(item?.employees?.age) <= 58) {
      return total + Number(item.epf_wages);
    }
    return total;
  },0)

  logger.log(totalEPSWages, "totalEPSWages1000");

  return (
    <>
      <Document>
        <Page size="A4" orientation="landscape" style={reportStyles.page}>
          <View fixed>
            <ReportHeader organizationInfo={organizationInfo} />
            <View style={reportStyles.pdfHeaderTableHeadingwrapper}>
              <View>
                <Text style={reportStyles.pdfHeaderTableHeading}>
                  {`EPF Report of ${getMonthInStringNotOneIndexBased(epfReportPDFData[0]?.month)} ${epfReportPDFData[0]?.year}`}
                </Text>
              </View>
              {organizationInfo?.epf_organization_number && (
                <View>
                  <Text style={reportStyles.pdfHeaderTableHeading}>
                    Employer Code: {organizationInfo?.epf_organization_number}
                  </Text>
                </View>
              )}
            </View>
          </View>
            <View style={reportStyles.pdfHeaderTable}>
              <View style={reportStyles.pdfHeaderTableBx}>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Employee:</Text>
                  <Text>{epfReportSummary?.total_employee}</Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Salaried Employee:</Text>
                  <Text>{epfReportSummary?.total_salaried_employees}</Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Wages Employee:</Text>
                  <Text>{epfReportSummary?.total_wages_employees}</Text>
                </View>
              </View>

              <View style={reportStyles.pdfHeaderTableBx}>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total New Joniee:</Text>
                  <Text>
                    {epfReportSummary?.total_new_employees
                      ? epfReportSummary?.total_new_employees
                      : "0"}
                  </Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Left In Service:</Text>
                  <Text>
                    {epfReportSummary?.total_left_employees
                      ? epfReportSummary?.total_left_employees
                      : "0"}
                  </Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Leave Count In Whole Month:</Text>
                  <Text>
                    {epfReportSummary?.total_on_leave_employee
                      ? epfReportSummary?.total_on_leave_employee
                      : "0"}
                  </Text>
                </View>
              </View>

              <View style={reportStyles.pdfHeaderTableBx}>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total EPF Member:</Text>
                  <Text>
                    {epfReportSummary?.total_epf_member
                      ? epfReportSummary?.total_epf_member
                      : "0"}
                  </Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Non-EPF Member:</Text>
                  <Text>
                    {epfReportSummary?.total_non_epf_members
                      ? epfReportSummary?.total_non_epf_members
                      : "0"}
                  </Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total EPS Member:</Text>
                  <Text>{totalEmployeeUnder58 ? totalEmployeeUnder58 : '0'}</Text>
                </View>
              </View>

              <View style={reportStyles.pdfHeaderTableBx}>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Total Gross:</Text>
                  <Text>
                    {/* {epfReportSummary?.total_gross_wages
                      ? Number(epfReportSummary?.total_gross_wages).toFixed(2)
                      : "0"} */}
                    {epfReportSummary?.total_gross_wages
                      ? formatIndianCurrency(Math.round(Number(epfReportSummary?.total_gross_wages)))
                      : "0"}
                  </Text>
                </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total EPF Cover Gross:</Text>
                <Text>
                  {/* {epfReportSummary?.total_epf_cover_gross_wages
                    ? formatIndianCurrency(Math.round(Number(
                      epfReportSummary?.total_epf_cover_gross_wages
                    )))
                    : "00"} */}
                  {(epfReportSummary?.total_gross_wages && epfReportSummary?.total_epf_not_cover_gross_wages) ?
                    formatIndianCurrency(Math.round(Number(epfReportSummary?.total_gross_wages - epfReportSummary?.total_epf_not_cover_gross_wages))) : "00"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total Non-EPF Cover Gross:</Text>
                <Text>
                  {epfReportSummary?.total_epf_not_cover_gross_wages
                    ? formatIndianCurrency(Math.round(Number(
                      epfReportSummary?.total_epf_not_cover_gross_wages
                    )))
                    : "00"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total EPF Cover Wages:</Text>
                <Text>
                  {epfReportSummary?.total_epf_cover_gross_wages
                    ? formatIndianCurrency(Math.round(Number(
                      epfReportSummary?.total_epf_cover_gross_wages
                    )))
                    : "00"}
                </Text>
              </View>
              <View style={reportStyles.HeaderTableBxWrap}>
                <Text>Total EPS Cover Wages:</Text>
                <Text>
                  {totalEPSWages ? formatIndianCurrency(Math.round(Number(totalEPSWages))) : '00'}
                </Text>
              </View>
            </View>

              <View style={reportStyles.pdfHeaderTableBx}>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Employee Contribution:</Text>
                  <Text>
                    {epfReportSummary?.total_epf_contribution
                      ? formatIndianCurrency(Math.round(Number(
                        epfReportSummary?.total_epf_contribution
                      )))
                      : "00"}
                  </Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Employer Contribution (EPS):</Text>
                  <Text>
                    {/* {epfReportSummary?.total_eps_employeer_contribution
                      ? Math.round(Number(
                        epfReportSummary?.total_eps_employeer_contribution
                      ))
                      : "0"} */}
                      {totalEPSAmount? formatIndianCurrency(Math.round(Number(totalEPSAmount))):'0'}
                  </Text>
                </View>
                <View style={reportStyles.HeaderTableBxWrap}>
                  <Text>Employer Contribution (EPF):</Text>
                  <Text>
                    {/* {epfReportSummary?.total_epf_employeer_contribution
                      ? Math.round(Number(
                        epfReportSummary?.total_epf_employeer_contribution
                      ))
                      : "0"} */}
                      {totalEPFAmount? formatIndianCurrency(totalEPFAmount):'0'}
                  </Text>
                </View>
              </View>
            </View>

            <View style={reportStyles.ReportTable}>
              <View style={reportStyles.ReportTh} fixed>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "3%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  SL
                </Text>

                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    {
                      width: "10%",
                      borderRight: "1px solid #ccc",
                      textAlign: "left",
                    },
                  ]}
                >
                  UAN
                </Text>

                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    {
                      width: "15%",
                      textAlign: "left",
                      borderRight: "1px solid #ccc",
                    },
                  ]}
                >
                  EMPLOYEE NAME
                </Text>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  AGE AS OF
                </Text>

                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "13%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  EPF NO.
                </Text>

                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  PAYABLE DAYS
                </Text>

                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "9%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  NCP DAYS
                </Text>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  GROSS PAY
                </Text>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  EPF WAGES
                </Text>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  EPS WAGES
                </Text>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  EDLI WAGES
                </Text>
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "8%", borderRight: "1px solid #ccc" },
                  ]}
                >
                  EMPLOYEE CONTRIBUTION
                </Text>
                <View
                  style={[
                    reportStyles.ReportHeaderCell,
                    {
                      width: "9%",
                      borderRight: "1px solid #ccc",
                      padding: "0px",
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        borderBottom: "1px solid #ccc",
                        paddingVertical: "2px",
                      },
                    ]}
                  >
                    EMPLOYER CONTRIBUTION
                  </Text>
                  <View style={[reportStyles.ReportHeaderFlex]}>
                    <Text
                      style={{ borderRight: "1px solid #ccc", width: "50%" }}
                    >
                      EPS
                    </Text>
                    <Text style={{ width: "50%" }}>EPF</Text>
                  </View>
                </View>
             
                <Text style={[reportStyles.ReportHeaderCell, { width: "12%" }]}>
                  REMARKS
                </Text>
              </View>
              {epfReportPDFData?.map((item, index) => {
                const employerEPSPercentage = Number(
                  (item?.epf_wages * 8.33) / 100
                ).toFixed(2);
                const employerEPSAmount =
                  item?.employees?.age <= 58
                    ? employerEPSPercentage <= 1250
                      ? Math.ceil(employerEPSPercentage)
                      : 1250
                    : 0;
                const employerEPFAmount = Math.floor(Number(item?.ee_epf_amount - employerEPSAmount))
                return (
                  <>
                    <View style={reportStyles.ReportTd} wrap={false}>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "3%", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{index + 1}</Text>
                      </View>

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "10%", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>
                          {item?.employees?.uan_no
                            ? item?.employees?.uan_no
                            : "--"}
                        </Text>
                      </View>

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "15%",
                            textAlign: "left",
                            borderRight: "1px solid #ccc",
                          },
                        ]}
                      >
                        <Text>
                          {item?.employee_name ? item?.employee_name : "--"}
                        </Text>
                      </View>

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "5%",
                            borderRight: "1px solid #ccc",
                            textAlign: "center",
                          },
                        ]}
                      >
                        <Text>
                          {item?.employees?.age ? item?.employees?.age : "--"}
                        </Text>
                      </View>

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "13%", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>
                          {item?.employees?.epf_no
                            ? item?.employees?.epf_no
                            : "--"}
                        </Text>
                      </View>

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", borderRight: "1px solid #ccc",textAlign: "center", },
                        ]}
                      >
                        <Text>{item?.payable_days ? item?.payable_days : '00'}</Text>
                      </View>

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "9%", borderRight: "1px solid #ccc",textAlign: "center", },
                        ]}
                      >
                        <Text>{item?.ncp_days ? item?.ncp_days : '00'}</Text>
                      </View>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "5%",
                            borderRight: "1px solid #ccc",
                            textAlign: "right",
                          },
                        ]}
                      >
                        <Text>
                          {/* {item?.gross_salary ? item?.gross_salary : "--"} */}
                          {item?.gross_salary ? formatIndianCurrency(Math.round(Number(item?.gross_salary))) : "00"}

                        </Text>
                      </View>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "5%",
                            borderRight: "1px solid #ccc",
                            textAlign: "right",
                          },
                        ]}
                      >
                        {/* EPF Wages */}
                        <Text>{item?.epf_wages ? formatIndianCurrency(item?.epf_wages.toFixed()) : "00"}</Text>
                      </View>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "5%",
                            borderRight: "1px solid #ccc",
                            textAlign: "right",
                          },
                        ]}
                      >
                        {/* EPS Wages */}
                        <Text>
                          {item?.epf_wages
                            ? item?.employees?.age <= "58"
                              ? formatIndianCurrency(item?.epf_wages.toFixed())
                              : " NA "
                            : "00"}
                        </Text>
                      </View>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "5%",
                            borderRight: "1px solid #ccc",
                            textAlign: "right",
                          },
                        ]}
                      >
                        {/* EDLI Wages */}
                        <Text>{item?.epf_wages ? formatIndianCurrency(item?.epf_wages.toFixed()) : "00"}</Text>
                      </View>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "8%", borderRight: "1px solid #ccc", textAlign: "right", },
                        ]}
                      >
                        {/* Employee Contribution */}
                        <Text>
                          {item?.epf_amount ? formatIndianCurrency(item?.epf_amount.toFixed()) : "00"}
                        </Text>
                      </View>
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          {
                            width: "9%",
                            borderRight: "1px solid #ccc",
                            display: "flex",
                            flexDirection: "row",
                            padding: "0px",
                          },
                        ]}
                      >
                        <View
                          style={{
                            width: "50%",
                            borderRight: "1px solid #ccc",
                            padding: "2px", textAlign: "right",
                          }}
                        >
                          <Text>
                            {item?.employees?.age <= "58"
                              ? formatIndianCurrency(employerEPSAmount)
                              : "NA"}
                          </Text>
                        </View>
                        <View style={{ width: "50%", padding: "2px", textAlign: "right", }}>
                          <Text>{formatIndianCurrency(employerEPFAmount)}</Text>
                        </View>
                      </View>
                  
                      <View
                        style={[reportStyles.ReportTdCell, { width: "12%" }]}
                      >
                        <Text>
                          {(() => {
                            const joinDate = item?.employees?.join_date ? new Date(item.employees.join_date) : null;
                            const exitDate = item?.employees?.exit_formalities?.[0]?.exit_date ? new Date(item.employees.exit_formalities[0].exit_date) : null;
                            const recordMonth = item?.month;
                            const recordYear = item?.year;

                            if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
                              return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                            }
                            if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
                              return `The Employee exited on ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                            }
                            return item?.remarks || "--";
                          })()}
                        </Text>
                      </View>
                    </View>
                  </>
                );
              })}
            </View>
          <View style={reportStyles.footer} fixed>
            <Text>
              Download Time & date: {dayjs().format("DD-MM-YYYY hh:mm A")}{" "}
            </Text>
            <Text
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </Page>
      </Document>
    </>
  );
};
export default EPFPdf;
